import { RtlLangs } from 'forms-utils-lib/language/LanguageConstants';
export const getIsRtlLang = lang => lang && typeof lang === 'string' ? RtlLangs.includes(lang.split('-')[0]) : false;